"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var FRAME_URL = 'https://www.yy.com/web/yycom_public/index.html';
var util_1 = require("~/js/lib/util/util");
var FRAME_ID = 'crossDomainShareFrame';
var Frame = (function () {
    function Frame() {
    }
    Frame.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var frameEl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        frameEl = document.getElementById(FRAME_ID);
                        if (!!frameEl) return [3, 2];
                        return [4, util_1.makeAwait(function (next) {
                                frameEl = document.createElement('iframe');
                                frameEl.id = FRAME_ID;
                                frameEl.onload = function () {
                                    next();
                                };
                                frameEl.src = FRAME_URL;
                                frameEl.style.cssText = 'position: absolute; left: -500px; top: -500px; width: 0; height: 0;';
                                document.body.appendChild(frameEl);
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.frame = frameEl;
                        return [2];
                }
            });
        });
    };
    Frame.prototype.getItem = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.frame) return [3, 2];
                        return [4, this.init()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        r = '';
                        try {
                            r = this.frame.contentWindow.localStorage.getItem(name);
                        }
                        catch (er) {
                        }
                        return [2, r];
                }
            });
        });
    };
    Frame.prototype.setItem = function (name, jsonstr) {
        return __awaiter(this, void 0, void 0, function () {
            var contentWindow;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.frame) return [3, 2];
                        return [4, this.init()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        contentWindow = this.frame.contentWindow;
                        try {
                            contentWindow.localStorage.setItem(name, jsonstr);
                        }
                        catch (er) {
                            if (er.name === 'QuotaExceededError') {
                                contentWindow.localStorage.clear();
                                contentWindow.localStorage.setItem(name, jsonstr);
                            }
                        }
                        contentWindow.postMessage(JSON.stringify({
                            type: 'set',
                            key: name,
                            value: jsonstr
                        }), window.location.protocol + "//" + window.location.hostname);
                        return [2];
                }
            });
        });
    };
    Frame.prototype.clear = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.frame) return [3, 2];
                        return [4, this.init()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.frame.contentWindow.localStorage.clear();
                        return [2];
                }
            });
        });
    };
    return Frame;
}());
exports.Frame = Frame;
